module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxyZWN0IHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgcng9IjUiIGZpbGw9IiM0MjQyNDIiLz4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMyAxM0w1LjMzMzMzIDEwLjY2NjdMMTAgMTUuMzMzM0wxOS4zMzMzIDZMMjEuNjY2NyA4LjMzMzMzTDEwIDIwTDMgMTNaIiBmaWxsPSIjMUYxRjFGIiBzdHJva2U9IiMxRjFGMUYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdrawSetup/choose2.svg
// module id = dZzg
// module chunks = 0